import { ItemList } from "../../orm";

class AdminUsersList extends ItemList {

  getEntityKey() {
    return "admin/user";
  }

}

export const adminUsersList = new AdminUsersList("admin_users__default");
